import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import apiInstanceV2 from "../../Apis/AxiosV2";
const serviceName = "traffic-fine-service";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const GetGeofenceById = createAsyncThunk('trafficFine/getGeofenceById', async (id, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/geofences/${id}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateGeofence = createAsyncThunk("trafficFine/createGeofence",async (params, { dispatch, getState }) => {
    const response = await apiInstance.post(`${serviceName}/v1/geofences/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateGeofence = createAsyncThunk("trafficFine/updateGeofence",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(`${serviceName}/v1/geofences/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetGeofenceList = createAsyncThunk('trafficFine/getGeofenceList', async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(`${serviceName}/v1/geofences/get-all`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const UpdateGeofenceHierarchyLevel = createAsyncThunk("trafficFine/updateGeofenceHierarchyLevel",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(`${serviceName}/v1/geofences/update-hierarchy-Level`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateGeofenceStatus = createAsyncThunk("trafficFine/updateGeofenceStatus",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(`${serviceName}/v1/geofences/update-status`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetGeofenceConfigSettingByGeofenceId = createAsyncThunk("trafficFinesSection/GetGeofenceConfigSetting",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${serviceName}/v1/geofence-config/geofence-id/${params}`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
